document.addEventListener('click', (event) => {
  const printBtn = event.target.closest('[data-post-hero-print]');
  if (!printBtn) return;

  event.preventDefault();
  window.print();
});
